import React, { useEffect, useState } from "react";
import "../styles/watchlist.css";
import { Link } from "react-router-dom";
import { all_ids } from "./Apis";

const formatVolume = (volume) => {
  if (volume >= 1000000000) {
    return (volume / 1000000000).toFixed(2) + "B";
  } else if (volume >= 1000000) {
    return (volume / 1000000).toFixed(2) + "M";
  } else if (volume >= 1000) {
    return (volume / 1000).toFixed(2) + "K";
  } else {
    return volume.toFixed(2).toString();
  }
};

const WatchList = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortValue, setSortValue] = useState("");
  const filteredTableData = tableData.filter((data) =>
    data[0].displayName.toLowerCase().startsWith(searchTerm.toLowerCase())
  );
  const instrumentIds = all_ids;

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSelectSortChange = (event) => {
    setSortValue(event.target.value);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const url = new URL(
          `https://assets.msn.com/service/Finance/Quotes?apikey=0QfOX3Vn51YCzitbLaRkTTBadtWpgTN8NZLW0C1SEM&activityId=E05F7449-9CA5-4AAB-9D82-AE864760EB95&ocid=finance-utils-peregrine&cm=en-in&ids=${instrumentIds}&wrapodata=false`
        );
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const json = await response.json();
        setTableData(json);
      } catch (error) {
        console.error("Network Error", error);
      }
    }
    try {
      fetchData();
    } catch (error) {
      console.log("Network issue", error);
    }
  }, [instrumentIds]);

  useEffect(() => {
    if (sortValue === "price_low_high") {
      setTableData([...tableData].sort((a, b) => a[0].price - b[0].price));
    } else if (sortValue === "price_high_low") {
      setTableData([...tableData].sort((a, b) => b[0].price - a[0].price));
    } else if (sortValue === "volume_low_high") {
      setTableData(
        [...tableData].sort((a, b) => {
          if (a[0].averageVolume && b[0].averageVolume) {
            return a[0].averageVolume - b[0].averageVolume;
          } else if (a[0].averageVolume) {
            return -1;
          } else {
            return 1;
          }
        })
      );
    } else if (sortValue === "volume_high_low") {
      setTableData(
        [...tableData].sort((a, b) => {
          if (b[0].averageVolume && a[0].averageVolume) {
            return b[0].averageVolume - a[0].averageVolume;
          } else if (b[0].averageVolume) {
            return 1;
          } else {
            return -1;
          }
        })
      );
    } else if (sortValue === "price_change_low_high") {
      setTableData(
        [...tableData].sort((a, b) => a[0].priceChange - b[0].priceChange)
      );
    } else if (sortValue === "price_change_high_low") {
      setTableData(
        [...tableData].sort((a, b) => b[0].priceChange - a[0].priceChange)
      );
    } else if ("") {
      setTableData([...tableData]);
    }
  }, [sortValue, tableData]);

  return (
    <div className="mmv_container">
      <div className="mmv_title_container">
        <h2 className="mmv_title">WatchList</h2>
        <p className="mmv_subtitle">
          Learn about Stock market updates today - Peek into Gainers, Losers, 52
          Week Highs, 52 week Lows and more.
        </p>
      </div>
      <div className="mmv_tables">
        <div className="mmv_datatable">
          <div className="table_headers">
            <h5 className="table_title">Market Movers</h5>
            <input
              type="text"
              placeholder="Search.."
              className="table_search"
              value={searchTerm}
              onChange={handleSearch}
            />
            <select
              className="table_search sort_bar"
              onChange={handleSelectSortChange}
            >
              <option className="" value="">
                Select for sort
              </option>
              <option className="" value="price_low_high">
                Price Low - High
              </option>
              <option className="" value="price_high_low">
                Price High - Low
              </option>
              <option className="" value="volume_low_high">
                Volume Low - High
              </option>
              <option className="" value="volume_high_low">
                Volume High - Low
              </option>
              <option className="" value="price_change_low_high">
                Price Change Low - High
              </option>
              <option className="" value="price_change_high_low">
                Price Change High - Low
              </option>
            </select>
          </div>
          <div className="table_container">
            <table className="table table_head">
              <thead className="table_head">
                <tr>
                  <th scope="col">Company</th>
                  <th scope="col">Ex. Code</th>
                  <th scope="col">Price</th>
                  <th scope="col">Change (Rate)</th>
                  <th scope="col" className="display_630">
                    Avg Volume
                  </th>
                  <th scope="col" className="display_700">
                    Price Day L/H
                  </th>
                  <th scope="col" className="display_780">
                    Price 52Week L/H
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredTableData.map((data) => {
                  return (
                    <tr key={data[0].instrumentId}>
                      <td>
                        <Link
                          className="complink"
                          to={`/markets/company/${data[0].displayName} ${data[0].instrumentId}`}
                        >
                          {data[0].displayName}
                        </Link>
                      </td>
                      <td
                        className="Number tooltip_container"
                        value={data[0].exchangeCode}
                      >
                        {data[0].exchangeCode}
                        <span className="tooltip_text">
                          {data[0].exchangeName}
                        </span>
                      </td>
                      <td
                        className="Number"
                        value={data[0].price}
                        style={{
                          color: data[0].priceChange < 0 ? "red" : "#04b03e",
                        }}
                      >
                        {data[0].price}
                      </td>
                      <td
                        className="Number"
                        value={data[0].priceChange}
                        style={{
                          color: data[0].priceChange < 0 ? "red" : "#04b03e",
                        }}
                      >
                        {data[0].priceChange} (
                        {data[0].priceChangePercent &&
                          data[0].priceChangePercent.toFixed(2)}
                        %)
                      </td>
                      <td
                        className="Number display_630"
                        value={data[0].averageVolume}
                        style={{
                          color: "#0078ff",
                        }}
                      >
                        {(data[0].averageVolume &&
                          formatVolume(data[0].averageVolume)) ||
                          "-"}
                      </td>
                      <td
                        className="Number display_700"
                        value={data[0].priceDayLow}
                        style={{
                          color: "#0078ff",
                        }}
                      >
                        {data[0].priceDayLow &&
                          formatVolume(data[0].priceDayLow)}
                        {" - "}
                        {data[0].priceDayHigh &&
                          formatVolume(data[0].priceDayHigh)}
                      </td>
                      <td
                        className="Number display_780"
                        value={data[0].price52wLow}
                        style={{
                          color: "#0078ff",
                        }}
                      >
                        {data[0].price52wLow &&
                          formatVolume(data[0].price52wLow)}
                        {" - "}
                        {data[0].price52wHigh &&
                          formatVolume(data[0].price52wHigh)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchList;
